import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner } from '../spinner';
import s from './button.module.scss';
export const Button = ({ onClick, children, disabled, className, color = 'blue', isLoading = false, ...rest }) => (_jsxs("button", { className: `${s.button} ${s[color]} ${className}`, disabled: disabled, onClick: onClick, ...rest, children: [children, isLoading && _jsx(Spinner, { size: 'small', color: "#24323b" })] }));
